import { supabase } from '../lib/supabase';

export const stripeService = {
  // Create subscription checkout session
  async createSubscription(priceId, customerInfo) {
    try {
      console.log('Creating subscription with:', { priceId, customerInfo });
      
      const { data, error } = await supabase?.functions?.invoke('create-subscription', {
        body: {
          priceId,
          userId: customerInfo?.userId,
          customerInfo: {
            email: customerInfo?.email,
            name: customerInfo?.name
          }
        }
      });

      console.log('Supabase function response:', { data, error });

      if (error) {
        console.error('Supabase function error:', error);
        throw new Error(error?.message || 'Failed to create subscription');
      }

      return { data, error: null };
    } catch (error) {
      console.error('Stripe subscription error:', error);
      console.error('Error details:', {
        message: error.message,
        stack: error.stack,
        name: error.name
      });
      return { data: null, error: error?.message || 'Failed to create subscription' };
    }
  },

  // Cancel subscription
  async cancelSubscription(subscriptionId) {
    try {
      const { data, error } = await supabase?.functions?.invoke('cancel-subscription', {
        body: { subscriptionId }
      });

      if (error) {
        throw new Error(error?.message || 'Failed to cancel subscription');
      }

      return { data, error: null };
    } catch (error) {
      console.error('Cancel subscription error:', error);
      return { data: null, error: error?.message || 'Failed to cancel subscription' };
    }
  },

  // Get subscription plans
  async getSubscriptionPlans() {
    try {
      const { data, error } = await supabase?.from('subscription_plans')?.select('*')?.eq('is_active', true)?.order('amount_cents', { ascending: true });

      if (error) {
        throw error;
      }

      return { data: data || [], error: null };
    } catch (error) {
      console.error('Get subscription plans error:', error);
      return { data: [], error: error?.message || 'Failed to get subscription plans' };
    }
  },

  // Get user subscription
  async getUserSubscription(userId) {
    try {
      const { data, error } = await supabase?.from('user_subscriptions')?.select(`
          *,
          plan:subscription_plans(*)
        `)?.eq('user_id', userId)?.eq('status', 'active')?.order('created_at', { ascending: false })?.limit(1)?.single();

      return { data: data || null, error: error?.code === 'PGRST116' ? null : error };
    } catch (error) {
      console.error('Get user subscription error:', error);
      return { data: null, error: error?.message || 'Failed to get user subscription' };
    }
  },

  // Get payment transactions
  async getPaymentTransactions(userId) {
    try {
      const { data, error } = await supabase?.from('payment_transactions')?.select('*')?.eq('user_id', userId)?.order('created_at', { ascending: false });

      if (error) {
        throw error;
      }

      return { data: data || [], error: null };
    } catch (error) {
      console.error('Get payment transactions error:', error);
      return { data: [], error: error?.message || 'Failed to get payment transactions' };
    }
  },

  // Check if user is premium
  async checkUserPremiumStatus(userId) {
    try {
      const { data, error } = await supabase?.rpc('is_user_premium', {
        check_user_id: userId
      });

      if (error) {
        throw error;
      }

      return { data: Boolean(data), error: null };
    } catch (error) {
      console.error('Check premium status error:', error);
      return { data: false, error: error?.message || 'Failed to check premium status' };
    }
  },

  // Get user subscription details
  async getUserSubscriptionDetails(userId) {
    try {
      const { data, error } = await supabase?.rpc('get_user_subscription', {
        check_user_id: userId
      });

      return { data: data?.[0] || null, error };
    } catch (error) {
      console.error('Get user subscription details error:', error);
      return { data: null, error: error?.message || 'Failed to get subscription details' };
    }
  },

  // Format amount for display
  formatAmount(amountCents, currency = 'USD') {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency.toUpperCase(),
    })?.format(amountCents / 100);
  }
};